import { render, staticRenderFns } from "./OrderCreate.vue?vue&type=template&id=13fd7a57&scoped=true"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"
import style0 from "./OrderCreate.vue?vue&type=style&index=0&id=13fd7a57&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd7a57",
  null
  
)

export default component.exports